import React,{useState,useEffect} from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./system-components/navbar";

import {NewPage_2} from './pages';
import {Page1} from './pages';

















function App() {
  const [data, setData] = useState({
    cart: { items: [] },
  });
  const [privState, setPrivState] = useState(null);

  return (
    <Router>
      <Navbar data={data} setData={setData} />
      <Routes>

      













<Route path="/page1" element={<Page1 data={data} setData={setData} />} />
<Route path="/newpage_2" element={<NewPage_2 data={data} setData={setData} />} />
</Routes>
    </Router>
  );
}

export default App;
